import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Pencil, Check } from "lucide-react";
import { TabHeader } from "@/components/royal";

export default function Rules({ settings, saveSettings, editable }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(settings.rules_text || "");
  useEffect(() => { setDraft(settings.rules_text || ""); }, [settings.rules_text]);

  return (
    <div className="space-y-6">
      <TabHeader label="The Codex" title="Rules">
        {editable && !editing && (
          <Button variant="outline" size="sm" className="rounded-sm" onClick={() => setEditing(true)} data-testid="edit-rules">
            <Pencil strokeWidth={1.5} className="w-4 h-4 mr-1" /> Edit
          </Button>
        )}
        {editable && editing && (
          <Button size="sm" className="rounded-sm" data-testid="save-rules"
            onClick={async () => { await saveSettings({ rules_text: draft }); setEditing(false); }}>
            <Check strokeWidth={1.5} className="w-4 h-4 mr-1" /> Save Rules
          </Button>
        )}
      </TabHeader>

      {editing ? (
        <Textarea value={draft} onChange={(e) => setDraft(e.target.value)} rows={24}
          className="rounded-sm bg-background font-mono text-sm" data-testid="rules-textarea"
          placeholder="Paste the full HighThrone ruleset here…" />
      ) : (
        <div className="max-w-3xl mx-auto" data-testid="rules-content">
          {settings.rules_text ? (
            <div className="ht-panel p-8">
              <p className="text-base leading-relaxed whitespace-pre-wrap">{settings.rules_text}</p>
            </div>
          ) : (
            <div className="ht-panel p-12 text-center text-muted-foreground">The ruleset has not been published yet.</div>
          )}
        </div>
      )}
    </div>
  );
}
